// Identidad institucional para el membrete de documentos clínicos exportados.
// Datos reales entregados por el usuario (dueño del negocio) — no inventar ni
// derivar de copy de marketing (src/data/schemas.ts tiene una dirección
// genérica de SEO que no es válida para un documento legal).

export const CLINIC_IDENTITY = {
  razonSocial: 'Conectemos Chile SPA',
  nombreFantasia: 'Conectemos Chile',
  rut: '77.528.735-7',
  direccion: 'Bombero Adolfo Ossa 1010, Ofi. 204, salida paseo Ahumada, Metro U. de Chile, Santiago',
  telefono: '+56 9 2199 1963',
  email: 'conectemoscl@gmail.com',
  logoPath: '/assets/img/logo.png',
} as const;
